/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './ErrorRendererStyles.scss';
export function ErrorRenderer({ block }) {
    const err = block;
    const suggestions = Array.isArray(err.recovery_suggestions) ? err.recovery_suggestions : [];
    const actions = Array.isArray(err.actions) ? err.actions : [];
    return (React.createElement(AIGeneralBlockCard, { variant: "error", sections: [
            {
                label: err.title,
                content: (React.createElement(React.Fragment, null,
                    React.createElement(Text, { variant: "body" }, err.message),
                    suggestions.length > 0 && (React.createElement("ul", { className: "qmb-ui-error-renderer__suggestions" }, suggestions.map((s, idx) => (React.createElement("li", { key: idx },
                        React.createElement(Text, { variant: "body" }, s.label),
                        s.description && React.createElement(Text, { variant: "x-small" }, s.description)))))))),
                copyText: `${err.title}\n${err.message}`,
            },
        ], footerGroups: actions.length > 0 ? [{
                actions: actions.map((a, idx) => ({
                    id: `error-action-${idx}`,
                    label: a.label,
                    icon: a.icon,
                    onClick: () => {
                        // Actions dispatch through the parent's action handler via blockRegistry onAction
                        // No-op here — ErrorRenderer doesn't own action dispatch
                    },
                    variant: a.variant === 'danger' ? 'danger' : 'default',
                })),
            }] : [] }));
}
